import Vue from 'vue'
export default {
  onAppLaunch(vm) {
    Vue.prototype.$priceText = (price) => {
      if(price === null || price === undefined || price === '') price = 0
      return `新台幣${price}元`
    }
    Vue.prototype.$bonusText = (bonus_exchange) => {
      if(bonus_exchange === null || bonus_exchange === undefined || bonus_exchange === '') bonus_exchange = 0
      return `紅利${bonus_exchange}點`
    }
    Vue.prototype.$moneyText = (is_bonus, money) => {
      if(is_bonus) return vm.$bonusText(money)
      return vm.$priceText(money)
    }
  }
}